/**
 * Legacy Bootstrap
 *
 * This module registers legacy-specific concerns that v2 code should NOT use directly.
 * All legacy imports are isolated here to keep v2 clean.
 *
 * TODO: Remove this file once all legacy code is migrated to v2
 */
import type { App } from 'vue';

// Legacy styles
import '@/assets/sass/style.scss';

// Legacy Vuex store
import store from '@/store';

// Legacy global components
import FormGroup from '@/components/form/FormGroup.vue';

// Legacy singletons with side effects
import '@/components/annotations/composables/annotationHoverManager';

/**
 * Register legacy plugins, global components, and singletons on the Vue app instance.
 * Called from v2/main.ts after v2-native setup.
 */
export function bootstrapLegacy(app: App): void {
  // Vuex store (legacy state management)
  app.use(store);

  // Global components used throughout legacy codebase
  app.component('form-group', FormGroup);
}
